
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle/[listingId]",
      function () {
        return require("private-next-pages/vehicle/[listingId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle/[listingId]"])
      });
    }
  